import script from "./ServicesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesComponent.vue?vue&type=script&setup=true&lang=js"

import "./ServicesComponent.vue?vue&type=style&index=0&id=a2d25c34&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2d25c34"]])

export default __exports__